import { render, staticRenderFns } from "./MetaBanner.vue?vue&type=template&id=04610094&"
import script from "./MetaBanner.vue?vue&type=script&lang=ts&"
export * from "./MetaBanner.vue?vue&type=script&lang=ts&"
import style0 from "./MetaBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports